import React, { FC } from 'react';

import { fontFamilies } from 'components/UI/Font';

export const DescriptionItem: FC<{
  descriptionNode: React.ReactNode | string;
  desktopVisible: boolean;
  mobileVisible: boolean;
  onMobileClick: () => void;
  title?: string;
}> = ({ onMobileClick, desktopVisible, mobileVisible, descriptionNode, title }) => {
  if (!descriptionNode) {
    return <></>;
  }

  return (
    <div className="item-container">
      <div
        className="item-button-mobile mobile-flex"
        onClick={() => {
          onMobileClick();
        }}
      >
        <h2 className="title">{title || 'Description'}</h2>
        <i className={mobileVisible ? 'icon-angle-up' : 'icon-angle-down'} />
      </div>

      {desktopVisible && <div className="item-description desktop">{descriptionNode}</div>}
      {mobileVisible && <div className="item-description mobile">{descriptionNode}</div>}
      <style jsx>
        {`
          .item-container {
            width: 100%;
          }

          .item-button-mobile {
            justify-content: space-between;
            padding: 30px 0 25px 0;
            border-bottom: 1px solid #eceeef;
          }
          .item-button-mobile > * {
            display: flex;
          }
          .item-button-mobile i {
            font-size: 17px;
          }

          .title {
            font-family: ${fontFamilies.bold};
          }

          @keyframes fadeIn {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
          .item-description {
            width: 100%;
            margin: 20px 0;
          }
          @media (max-width: 1023px) {
            .item-description {
              animation: fadeIn 0.5s ease-in-out 1;
            }
          }
          @media (min-width: 1024px) {
            .item-description {
              max-width: 610px;
            }
          }
        `}
      </style>
    </div>
  );
};
